import { ManageAnnuitiesComponent } from "./manage-annuities/manage-annuities.component";
import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { ManageSubscriptionsComponent } from "./manage-subscriptions.component";
import { ManageAdkdetailsComponent } from "./manage-adkdetails/manage-adkdetails.component";
import { ManageCspDetailsComponent } from "./manage-cspdetails/manage-cspdetails.component";
import { ManageSubscriptiondetailsComponent } from "./manage-subscriptiondetails/manage-subscriptiondetails.component";
import { CreateEndUserComponent } from "./manage-annuities/create-end-user/create-end-user.component";
import { AssociateExistingEndUserComponent } from "./manage-annuities/associate-existing-end-user/associate-existing-end-user.component";
import { EditEndUserDetailComponent } from "./manage-cspdetails/edit-end-user-detail/edit-end-user-detail.component";
import { AddSubscriptionsComponent } from "./manage-cspdetails/add-subscriptions/add-subscriptions.component";
import { AddPerpetualComponent } from "./manage-cspdetails/add-perpetual/add-perpetual.component";
import { AddAzureRiComponent } from "./manage-cspdetails/add-azure-ri/add-azure-ri.component";
import { SelectAzureRiComponent } from "./manage-cspdetails/add-azure-ri/select-azure-ri/select-azure-ri.component";
import { AddSoftwareComponent } from "./manage-cspdetails/add-software/add-software.component";
import { AddAddonComponent } from "./manage-cspdetails/add-addon/add-addon.component";
import { PendingChangesGuard } from "../shared/pending-changes-guard.guard";
import { AddAdkSubscriptionComponent } from "./manage-adkdetails/add-adk-subscription/add-adk-subscription.component";
import { EditPaymentDetailComponent } from "./manage-cspdetails/edit-payment-detail/edit-payment-detail.component";
import { AddProductsComponent } from "./manage-cspdetails/add-product/add-product.component";
import { ConfirmProductsComponent } from "./manage-cspdetails/add-product/confirm-product/confirm-product.component";
import { SubscriptionEditPayment } from "./shared/subscription-edit-payment/subscription-edit-payment.component";
import { ConfigurePortalManagement } from "./manage-cspdetails/configure-portal-management/configure-portal-management.component";
import { ManageSPLAComponent } from "./programs/SPLA/manage-spla.component";
import { ManageISVComponent } from "./programs/ISV/manage-isv.component";
import { ManageIsvdetailsComponent } from "./programs/ISV/manage-isvdetails/manage-isvdetails.component";
import { AddIsvSubscriptionsComponent } from "./programs/ISV/manage-isvdetails/add-isv-subscriptions/add-isv-subscriptions.component";
import { ManageCitrixCSPComponent } from "./programs/CitrixCSP/manage-citrixcsp.component";
import { AddCitrixCSPSubscriptionsComponent } from "./programs/CitrixCSP/manage-citrixcspdetails/add-citrixcsp-subscriptions/add-citrixcsp-subscriptions.component";
import { ManageCitrixCSPdetailsComponent } from "./programs/CitrixCSP/manage-citrixcspdetails/manage-citrixcspdetails.component";
import { ManageTeleSmartComponent } from "./programs/TELE/manage-tele.component";
import { ManageTeleSmartdetailsComponent } from "./programs/TELE/manage-teledetails/manage-teledetails.component";
import { AddTeleSmartSubscriptionsComponent } from "./programs/TELE/manage-teledetails/add-tele-subscriptions/add-tele-subscriptions.component";
import { AddINTASubscriptionsComponent } from "./programs/INTA/manage-intadetails/add-inta-subscriptions/add-inta-subscriptions.component";
import { ManageINTAdetailsComponent } from "./programs/INTA/manage-intadetails/manage-intadetails.component";
import { ManageINTAComponent } from "./programs/INTA/manage-inta.component";
import { ManageWiiseComponent } from "./programs/WIISE/manage-wiise.component";
import { ManageWiisedetailsComponent } from "./programs/WIISE/manage-wiisedetails/manage-wiisedetails.component";
import { AddWiiseSubscriptionsComponent } from "./programs/WIISE/manage-wiisedetails/add-wiise-subscriptions/add-wiise-subscriptions.component";
import { ManageCISCOSAASComponent } from "./programs/CISCOSAAS/manage-ciscosaas.component";
import { ManageCISCOSAASdetailsComponent } from "./programs/CISCOSAAS/manage-ciscosaasdetails/manage-ciscosaasdetails.component";
import { AddCISCOSAASSubscriptionsComponent } from "./programs/CISCOSAAS/manage-ciscosaasdetails/add-ciscosaas-subscriptions/add-ciscosaas-subscriptions.component";
import { ManageCISCOComponent } from "./programs/CISCOMSP/manage-ciscomsp.component";
import { ManageCISCOdetailsComponent } from "./programs/CISCOMSP/manage-ciscomspdetails/manage-ciscomspdetails.component";
import { AddCISCOSubscriptionsComponent } from "./programs/CISCOMSP/manage-ciscomspdetails/add-ciscomsp-subscriptions/add-ciscomsp-subscriptions.component";
import { ManageTMMSPComponent } from "./programs/TMMSP/manage-tmmsp.component";
import { ManageTMMSPdetailsComponent } from "./programs/TMMSP/manage-tmmspdetails/manage-tmmspdetails.component";
import { AddTMMSPSubscriptionsComponent } from "./programs/TMMSP/manage-tmmspdetails/add-tmmsp-subscriptions/add-tmmsp-subscriptions.component";
import { ManageStorageCraftCComponent } from "./programs/SC/manage-sc.component";
import { ManageStorageCraftdetailsComponent } from "./programs/SC/manage-scdetails/manage-scdetails.component";
import { AddStorageCraftSubscriptionsComponent } from "./programs/SC/manage-scdetails/add-sc-subscriptions/add-sc-subscriptions.component";
import { SplaEditPayment } from "./shared/spla-edit-payment/spla-edit-payment.component";
import { ManageSpladetailsComponent } from "./manage-spladetails/manage-spladetails.component";
import { AddSplaSubscriptionsComponent } from "./manage-spladetails/add-spla-subscriptions/add-spla-subscriptions.component";
import { ManageSPLAdetailsComponent } from "./programs/SPLA/manage-spladetails/manage-spladetails.component";
import { AddSPLASubscriptionsComponent } from "./programs/SPLA/manage-spladetails/add-spla-subscriptions/add-spla-subscriptions.component";
import { ManageKASPComponent } from "./programs/KASP/manage-kasp.component";
import { ManageKaspDetailsComponent } from "./programs/KASP/manage-kasp-details/manage-kasp-details.component";
import { AddKaspSubscriptionComponent } from "./programs/KASP/manage-kasp-details/add-kasp-subscription/add-kasp-subscription.component";
import { EditKaspEndUserComponent } from "./programs/KASP/manage-kasp-details/edit-kasp-end-user/edit-kasp-end-user.component";
import { CreateKaspEndUserComponent } from "./programs/KASP/create-kasp-end-user/create-kasp-end-user.component";
import { AddDigitalWalletComponent } from "./shared/add-digital-wallet/add-digital-wallet.component";
import { ManageLicenseSubscriptionComponent } from "./manage-cspdetails/manage-license-subscription/manage-license-subscription.component";
import { ManageAzureSubscriptionComponent } from './manage-cspdetails/manage-azure-subscription/manage-azure-subscription.component';
import { ConfirmUpgradeComponent } from "./manage-cspdetails/manage-license-subscription/confirm-upgrade/confirm-upgrade.component";
import { BudgetAndAlertsComponent } from "./manage-cspdetails/manage-azure-subscription/budget-and-alerts/budget-and-alerts.component";
import { BudgetAndAlertsDetailsComponent } from "./manage-cspdetails/manage-azure-subscription/budget-and-alerts/budget-and-alerts-details/budget-and-alerts-details.component";
import { BudgetAndAlertsEditComponent } from "./manage-cspdetails/manage-azure-subscription/budget-and-alerts/budget-and-alerts-edit/budget-and-alerts-edit.component";
import { ManageReservedInstanceComponent } from "./manage-cspdetails/manage-reserved-instance/manage-reserved-instance.component";
import { CreateWatcGuardContractComponent } from "./manage-watchguards/create-watchguard-contract/create-watchguard-contract.component";
import { WGSEndUserDetailsEditComponent } from "./manage-watchguards/manage-wgs-end-user/wgs-end-user-details-edit/wgs-end-user-details-edit.component";
import { ConfirmWGSProductsComponent } from "./manage-watchguards/manage-wgs-end-user/add-product/confirm-wgs-product/confirm-wgs-product.component";
import { ManageWatchguardSubscriptionComponent } from "./manage-watchguards/manage-wgs-end-user/manage-watchguard-subscription/manage-watchguard-subscription.component";
import { ManageWGSEndUserComponent } from "./manage-watchguards/manage-wgs-end-user/manage-wgs-end-user.component";
import { AddWGSProductsComponent } from "./manage-watchguards/manage-wgs-end-user/add-product/add-wgs-product.component";
import { BulkAssociateComponent } from "./manage-annuities/bulk-associate/bulk-associate.component";
import { ManageSKReadOnlyComponent } from './manage-skreadonlydetails/manage-skreadonlydetails.component';
import { CreateAMPResellerComponent } from "./manage-adobe-marketplace/create-amp-reseller/create-amp-reseller.component";
import { CreateAMPCustomerComponent } from "./manage-adobe-marketplace/create-amp-customer/create-amp-customer.component";
import { ManageAMPCustomerComponent } from "./manage-adobe-marketplace/manage-amp-customer/manage-amp-customer.component";
import { BulkOrderComponent } from "./manage-annuities/bulk-order/bulk-order.component";
import { AMPCustomerDetailsEditComponent } from "./manage-adobe-marketplace/manage-amp-customer/amp-customer-details-edit/amp-customer-details-edit.component";
import { ManageAMPSubscriptionComponent } from "./manage-adobe-marketplace/manage-amp-customer/manage-amp-subscription/manage-amp-subscription.component";
import { AssociateAdobeCustomerComponent } from "./manage-annuities/associate-adobe-customer/associate-adobe-customer.component";
import { AddAMPProductsComponent } from "./manage-adobe-marketplace/manage-amp-customer/add-amp-product/add-amp-product.component";
import { ConfirmAMPProductsComponent } from "./manage-adobe-marketplace/manage-amp-customer/add-amp-product/confirm-amp-product/confirm-amp-product.component";
import { AMPSubscriptionCancellationComponent } from "./manage-adobe-marketplace/manage-amp-customer/manage-amp-subscription/amp-subscription-cancellation/amp-subscription-cancellation.component";
import { ManageCirrusComponent } from "./programs/CIRRUS/manage-cirrus.component";
import { ManageCirrusDetailsComponent } from "./programs/CIRRUS/manage-cirrus-details/manage-cirrus-details.component";
import { AddCirrusSubscriptionComponent } from "./programs/CIRRUS/manage-cirrus-details/add-cirrus-subscription/add-cirrus-subscription.component";
import { EditCirrusEndUserComponent } from "./programs/CIRRUS/manage-cirrus-details/edit-cirrus-end-user/edit-cirrus-end-user.component";
import { CreateCirrusEndUserComponent } from "./programs/CIRRUS/create-cirrus-end-user/create-cirrus-end-user.component";
import { AMPResellerEditComponent } from "./manage-adobe-marketplace/amp-reseller-edit/amp-reseller-edit.component";
import { VIPMarketPlaceMigrationsComponent } from "./manage-annuities/vip-market-place-migrations/vip-market-place-migrations.component";
import { AddAMPProductsV2Component } from "./manage-adobe-marketplace/manage-amp-customer/add-amp-product/add-amp-product-v2.component";
import { ManageAMPSubscriptionScheduledComponent } from "./manage-adobe-marketplace/manage-amp-customer/manage-amp-subscription-scheduled/manage-amp-subscription-scheduled.component";
import { VIPMarketPlaceBulkMigrationsComponent } from "./manage-annuities/vip-market-place-bulk-migrations/vip-market-place-bulk-migrations.component"
import { ConfirmRenewalComponent } from "./manage-cspdetails/manage-license-subscription/confirm-renewal/confirm-renewal.component";
import { RenewAMPProductsComponent } from "./manage-adobe-marketplace/manage-amp-customer/add-amp-product/renew-amp-product/renew-amp-product.component";
import { RenewAMPProductsHGOComponent } from "./manage-adobe-marketplace/manage-amp-customer/add-amp-product/renew-amp-product-hgo/renew-amp-product-hgo.component";
import { ViewHighGrowthOffersComponent } from "./manage-adobe-marketplace/manage-amp-customer/add-amp-product/view-high-growth-offers/view-high-growth-offers.component";
import { ConfirmProductsV2Component } from "./manage-cspdetails/add-product/confirm-product-v2/confirm-product-v2.component";
import { AMPEditPaymentDetailComponent } from "./manage-adobe-marketplace/manage-amp-customer/amp-edit-payment-detail/amp-edit-payment-detail.component";
import { BulkTransferComponent } from "./manage-annuities/bulk-transfer/bulk-transfer.component";
const routes: Routes = [
  {
    path: "manageSubscriptions",
    component: ManageSubscriptionsComponent,
    data: {
      breadcrumb: "Subscriptions",
    },
    children: [
      //Programs Route
      {
        path: '',
        children: [
          {
            path: 'KASP',
            component: ManageKASPComponent,
            data: {
              breadcrumb: 'Kaspersky MSP',
            },
            children: [
              {
                path: "createKaspEndUser",
                component: CreateKaspEndUserComponent,
                data: {
                  breadcrumb: "Create New End User",
                },
              },
              {
                path: "KASPDetails/:tenantId",
                component: ManageKaspDetailsComponent,
                canDeactivate: [PendingChangesGuard],
                data: {
                  breadcrumb: "tenantId",
                },
                children: [
                  {
                    path: "AddKASPSubscriptions",
                    component: AddKaspSubscriptionComponent,
                    data: {
                      breadcrumb: "Add KASP Subscriptions",
                    },
                  },
                  {
                    path: "EditEndUser",
                    component: EditKaspEndUserComponent,
                    data: {
                      breadcrumb: "Edit Tenant Details",
                    },
                  },
                  {
                    path: "EditPaymentDetails",
                    component: SubscriptionEditPayment,
                    data: {
                      breadcrumb: "Edit Tenant Details",
                    },
                    children: [
                      {
                        path: "CreateDigitalWallet",
                        component: AddDigitalWalletComponent,
                        data: {
                          breadcrumb: "Digital Wallet",
                        },
                      }
                    ]
                  },
                ],
              },
            ]
          },
          {
            path: 'CIRRUS',
            component: ManageCirrusComponent,
            data: {
              breadcrumb: 'Cirrus',
            },
            children: [
              {
                path: "CreateCirrusEndUser",
                component: CreateCirrusEndUserComponent,
                data: {
                  breadcrumb: "Create New End User",
                },
              },
              {
                path: "CirrusDetails/:tenantId",
                component: ManageCirrusDetailsComponent,
                canDeactivate: [PendingChangesGuard],
                data: {
                  breadcrumb: "tenantId",
                },
                children: [
                  {
                    path: "AddCIRRUSSubscriptions",
                    component: AddCirrusSubscriptionComponent,
                    data: {
                      breadcrumb: "Add CIRRUS Subscriptions",
                    },
                  },
                  {
                    path: "EditEndUser",
                    component: EditCirrusEndUserComponent,
                    data: {
                      breadcrumb: "Edit Tenant Details",
                    },
                  },
                  {
                    path: "EditPaymentDetails",
                    component: SubscriptionEditPayment,
                    data: {
                      breadcrumb: "Edit Tenant Details",
                    },
                    children: [
                      {
                        path: "CreateDigitalWallet",
                        component: AddDigitalWalletComponent,
                        data: {
                          breadcrumb: "Digital Wallet",
                        },
                      }
                    ]
                  },
                ],
              },
            ]
          },
          {
            path: 'INTA',
            component: ManageINTAComponent,
            data: {
              breadcrumb: 'Interactive Maintenance',
            },
            children: [
              {
                path:
                  "INTADetails/:annuityId/:orderNo/:vendorAgreementNo",
                component: ManageINTAdetailsComponent,
                data: {
                  breadcrumb: "vendorAgreementNo",
                },
                children: [
                  {
                    path: "AddINTASubscriptions",
                    component: AddINTASubscriptionsComponent,
                  },
                  {
                    path: "EditPaymentDetails",
                    component: SubscriptionEditPayment,
                    data: {
                      breadcrumb: "Edit Tenant Details",
                    },
                    children: [
                      {
                        path: "CreateDigitalWallet",
                        component: AddDigitalWalletComponent,
                        data: {
                          breadcrumb: "Digital Wallet",
                        },
                      }
                    ]
                  },
                ],
              },
              {
                path:
                  "INTADetails/:annuityId/:orderNo/:vendorAgreementNo/:orderSuffix",
                component: ManageINTAdetailsComponent,
                data: {
                  breadcrumb: "vendorAgreementNo",
                },
                children: [
                  {
                    path: "AddINTASubscriptions",
                    component: AddINTASubscriptionsComponent,
                  },
                  {
                    path: "EditPaymentDetails",
                    component: SubscriptionEditPayment,
                    data: {
                      breadcrumb: "Edit Tenant Details",
                    },
                    children: [
                      {
                        path: "CreateDigitalWallet",
                        component: AddDigitalWalletComponent,
                        data: {
                          breadcrumb: "Digital Wallet",
                        },
                      }
                    ]
                  },
                ],
              }
            ]
          },
          {
            path: 'SKBAK',
            component: ManageSKReadOnlyComponent,
            data: {
              breadcrumb: 'SkyKick Backup',
            },
            children: [
              {
                path:
                  "SKBAKDetails/:annuityId/:orderNo",
                component: ManageSKReadOnlyComponent,
                data: {
                  breadcrumb: "vendorAgreementNo",
                },
                children: [

                  {
                    path: "EditPaymentDetails",
                    component: SplaEditPayment,
                    data: {
                      breadcrumb: "Edit Tenant Details",
                    },
                  },
                ],
              }, {
                path:
                  "SKBAKDetails/:annuityId/:orderNo",
                component: ManageSKReadOnlyComponent,
                data: {
                  breadcrumb: "vendorAgreementNo",
                },
                children: [
                  {
                    path: "EditPaymentDetails",
                    component: SplaEditPayment,
                    data: {
                      breadcrumb: "Edit Tenant Details",
                    },
                  },
                ],
              }
            ]
          },
          {
            path: 'SKPLAT',
            component: ManageSKReadOnlyComponent,
            data: {
              breadcrumb: 'SkyKick Cloud Manager',
            },
            children: [
              {
                path:
                  "SKBAKDetails/:annuityId/:orderNo",
                component: ManageSKReadOnlyComponent,
                data: {
                  breadcrumb: "vendorAgreementNo",
                },
                children: [

                  {
                    path: "EditPaymentDetails",
                    component: SplaEditPayment,
                    data: {
                      breadcrumb: "Edit Tenant Details",
                    },
                  },
                ],
              }, {
                path:
                  "SKBAKDetails/:annuityId/:orderNo",
                component: ManageSKReadOnlyComponent,
                data: {
                  breadcrumb: "vendorAgreementNo",
                },
                children: [
                  {
                    path: "EditPaymentDetails",
                    component: SplaEditPayment,
                    data: {
                      breadcrumb: "Edit Tenant Details",
                    },
                  },
                ],
              }
            ]
          },
          {
            path: 'SPLA',
            component: ManageSPLAComponent,
            data: {
              breadcrumb: 'Microsoft SPLA',
            },
            children: [
              {
                path:
                  "SPLADetails/:annuityId/:orderNo/:vendorAgreementNo/:orderSuffix",
                component: ManageSPLAdetailsComponent,
                data: {
                  breadcrumb: "vendorAgreementNo",
                },
                children: [
                  {
                    path: "AddSplaSubscriptions",
                    component: AddSPLASubscriptionsComponent,
                  },
                  {
                    path: "EditPaymentDetails",
                    component: SplaEditPayment,
                    data: {
                      breadcrumb: "Edit Tenant Details",
                    },
                  },
                ],
              }, {
                path:
                  "SPLADetails/:annuityId/:orderNo/:vendorAgreementNo",
                component: ManageSPLAdetailsComponent,
                data: {
                  breadcrumb: "vendorAgreementNo",
                },
                children: [
                  {
                    path: "AddSplaSubscriptions",
                    component: AddSPLASubscriptionsComponent,
                  },
                  {
                    path: "EditPaymentDetails",
                    component: SplaEditPayment,
                    data: {
                      breadcrumb: "Edit Tenant Details",
                    },
                  },
                ],
              }
            ]
          },
          {
            path: 'ISV',
            component: ManageISVComponent,
            data: {
              breadcrumb: 'Microsoft ISV',
            },
            children: [
              {
                path:
                  "ISVDetails/:annuityId/:orderNo/:vendorAgreementNo/:orderSuffix",
                component: ManageIsvdetailsComponent,
                data: {
                  breadcrumb: "vendorAgreementNo",
                },
                children: [
                  {
                    path: "AddIsvSubscriptions",
                    component: AddIsvSubscriptionsComponent,
                  },
                  {
                    path: "EditPaymentDetails",
                    component: SplaEditPayment,
                    data: {
                      breadcrumb: "Edit Tenant Details",
                    },
                  },
                ],
              },
              {
                path:
                  "ISVDetails/:annuityId/:orderNo/:vendorAgreementNo",
                component: ManageIsvdetailsComponent,
                data: {
                  breadcrumb: "vendorAgreementNo",
                },
                children: [
                  {
                    path: "AddIsvSubscriptions",
                    component: AddIsvSubscriptionsComponent,
                  },
                  {
                    path: "EditPaymentDetails",
                    component: SplaEditPayment,
                    data: {
                      breadcrumb: "Edit Tenant Details",
                    },
                  },
                ],
              }
            ]
          },
          {
            path: 'CITRIXCSP',
            component: ManageCitrixCSPComponent,
            data: {
              breadcrumb: 'Citrix CSP',
            },
            children: [
              {
                path:
                  "CITRIXCSPDetails/:annuityId/:orderNo/:vendorAgreementNo/:orderSuffix",
                component: ManageCitrixCSPdetailsComponent,
                data: {
                  breadcrumb: "vendorAgreementNo",
                },
                children: [
                  {
                    path: "AddCITRIXCSPSubscriptions",
                    component: AddCitrixCSPSubscriptionsComponent,
                  },
                  {
                    path: "EditPaymentDetails",
                    component: SplaEditPayment,
                    data: {
                      breadcrumb: "Edit Tenant Details",
                    },
                  },
                ],
              },
              {
                path:
                  "CITRIXCSPDetails/:annuityId/:orderNo/:vendorAgreementNo",
                component: ManageCitrixCSPdetailsComponent,
                data: {
                  breadcrumb: "vendorAgreementNo",
                },
                children: [
                  {
                    path: "AddCITRIXCSPSubscriptions",
                    component: AddCitrixCSPSubscriptionsComponent,
                  },
                  {
                    path: "EditPaymentDetails",
                    component: SplaEditPayment,
                    data: {
                      breadcrumb: "Edit Tenant Details",
                    },
                  },
                ],
              }
            ]
          },
          {
            path: 'TELE',
            component: ManageTeleSmartComponent,
            data: {
              breadcrumb: 'Telesmart Teams Calling',
            },
            children: [
              {
                path:
                  "TELEDetails/:annuityId/:orderNo/:vendorAgreementNo/:orderSuffix",
                component: ManageTeleSmartdetailsComponent,
                data: {
                  breadcrumb: "vendorAgreementNo",
                },
                children: [
                  {
                    path: "AddTELESubscriptions",
                    component: AddTeleSmartSubscriptionsComponent,
                  },
                  {
                    path: "EditPaymentDetails",
                    component: SplaEditPayment,
                    data: {
                      breadcrumb: "Edit Tenant Details",
                    },
                  },
                ],
              },
              {
                path:
                  "TELEDetails/:annuityId/:orderNo/:vendorAgreementNo",
                component: ManageTeleSmartdetailsComponent,
                data: {
                  breadcrumb: "vendorAgreementNo",
                },
                children: [
                  {
                    path: "AddTELESubscriptions",
                    component: AddTeleSmartSubscriptionsComponent,
                  },
                  {
                    path: "EditPaymentDetails",
                    component: SplaEditPayment,
                    data: {
                      breadcrumb: "Edit Tenant Details",
                    },
                  },
                ],
              }
            ]
          },
          {
            path: 'WIISE',
            component: ManageWiiseComponent,
            data: {
              breadcrumb: 'Wiise MSP',
            },
            children: [
              {
                path:
                  "WIISEDetails/:annuityId/:orderNo/:vendorAgreementNo/:orderSuffix",
                component: ManageWiisedetailsComponent,
                data: {
                  breadcrumb: "vendorAgreementNo",
                },
                children: [
                  {
                    path: "AddWIISESubscriptions",
                    component: AddWiiseSubscriptionsComponent,
                  },
                  {
                    path: "EditPaymentDetails",
                    component: SplaEditPayment,
                    data: {
                      breadcrumb: "Edit Tenant Details",
                    },
                  },
                ],
              },
              {
                path:
                  "WIISEDetails/:annuityId/:orderNo/:vendorAgreementNo",
                component: ManageWiisedetailsComponent,
                data: {
                  breadcrumb: "vendorAgreementNo",
                },
                children: [
                  {
                    path: "AddWIISESubscriptions",
                    component: AddWiiseSubscriptionsComponent,
                  },
                  {
                    path: "EditPaymentDetails",
                    component: SplaEditPayment,
                    data: {
                      breadcrumb: "Edit Tenant Details",
                    },
                  },
                ],
              }
            ]
          },
          {
            path: 'CISCOSAAS',
            component: ManageCISCOSAASComponent,
            data: {
              breadcrumb: 'Cisco SaaS',
            },
            children: [
              {
                path:
                  "CISCOSAASDetails/:annuityId/:orderNo/:vendorAgreementNo/:orderSuffix",
                component: ManageCISCOSAASdetailsComponent,
                data: {
                  breadcrumb: "vendorAgreementNo",
                },
                children: [
                  {
                    path: "AddCISCOSAASSubscriptions",
                    component: AddCISCOSAASSubscriptionsComponent,
                  },
                  {
                    path: "EditPaymentDetails",
                    component: SplaEditPayment,
                    data: {
                      breadcrumb: "Edit Tenant Details",
                    },
                  },
                ],
              },
              {
                path:
                  "CISCOSAASDetails/:annuityId/:orderNo/:vendorAgreementNo",
                component: ManageCISCOSAASdetailsComponent,
                data: {
                  breadcrumb: "vendorAgreementNo",
                },
                children: [
                  {
                    path: "AddCISCOSAASSubscriptions",
                    component: AddCISCOSAASSubscriptionsComponent,
                  },
                  {
                    path: "EditPaymentDetails",
                    component: SplaEditPayment,
                    data: {
                      breadcrumb: "Edit Tenant Details",
                    },
                  },
                ],
              }
            ]
          },
          {
            path: 'CISCO',
            component: ManageCISCOComponent,
            data: {
              breadcrumb: 'Cisco MSP',
            },
            children: [
              {
                path:
                  "CISCODetails/:annuityId/:orderNo/:vendorAgreementNo/:orderSuffix",
                component: ManageCISCOdetailsComponent,
                data: {
                  breadcrumb: "vendorAgreementNo",
                },
                children: [
                  {
                    path: "AddCISCOSubscriptions",
                    component: AddCISCOSubscriptionsComponent,
                  },
                  {
                    path: "EditPaymentDetails",
                    component: SplaEditPayment,
                    data: {
                      breadcrumb: "Edit Tenant Details",
                    },
                  },
                ],
              },
              {
                path:
                  "CISCODetails/:annuityId/:orderNo/:vendorAgreementNo",
                component: ManageCISCOdetailsComponent,
                data: {
                  breadcrumb: "vendorAgreementNo",
                },
                children: [
                  {
                    path: "AddCISCOSubscriptions",
                    component: AddCISCOSubscriptionsComponent,
                  },
                  {
                    path: "EditPaymentDetails",
                    component: SplaEditPayment,
                    data: {
                      breadcrumb: "Edit Tenant Details",
                    },
                  },
                ],
              }
            ]
          },
          {
            path: 'TMMSP',
            component: ManageTMMSPComponent,
            data: {
              breadcrumb: 'Trend Micro MSP',
            },
            children: [
              {
                path:
                  "TMMSPDetails/:annuityId/:orderNo/:vendorAgreementNo/:orderSuffix",
                component: ManageTMMSPdetailsComponent,
                data: {
                  breadcrumb: "vendorAgreementNo",
                },
                children: [
                  {
                    path: "AddTMMSPSubscriptions",
                    component: AddTMMSPSubscriptionsComponent,
                  },
                  {
                    path: "EditPaymentDetails",
                    component: SplaEditPayment,
                    data: {
                      breadcrumb: "Edit Tenant Details",
                    },
                  },
                ],
              },
              {
                path:
                  "TMMSPDetails/:annuityId/:orderNo/:vendorAgreementNo",
                component: ManageTMMSPdetailsComponent,
                data: {
                  breadcrumb: "vendorAgreementNo",
                },
                children: [
                  {
                    path: "AddTMMSPSubscriptions",
                    component: AddTMMSPSubscriptionsComponent,
                  },
                  {
                    path: "EditPaymentDetails",
                    component: SplaEditPayment,
                    data: {
                      breadcrumb: "Edit Tenant Details",
                    },
                  },
                ],
              }
            ]
          },
          {
            path: 'STMSP',
            component: ManageStorageCraftCComponent,
            data: {
              breadcrumb: 'STORAGE CRAFT',
            },
            children: [
              {
                path:
                  "STMSPDetails/:annuityId/:orderNo/:vendorAgreementNo/:orderSuffix",
                component: ManageStorageCraftdetailsComponent,
                data: {
                  breadcrumb: "vendorAgreementNo",
                },
                children: [
                  {
                    path: "AddSCSubscriptions",
                    component: AddStorageCraftSubscriptionsComponent,
                  },
                  {
                    path: "EditPaymentDetails",
                    component: SplaEditPayment,
                    data: {
                      breadcrumb: "Edit Tenant Details",
                    },
                  },
                ],
              },
              {
                path:
                  "STMSPDetails/:annuityId/:orderNo/:vendorAgreementNo",
                component: ManageStorageCraftdetailsComponent,
                data: {
                  breadcrumb: "vendorAgreementNo",
                },
                children: [
                  {
                    path: "AddSCSubscriptions",
                    component: AddStorageCraftSubscriptionsComponent,
                  },
                  {
                    path: "EditPaymentDetails",
                    component: SplaEditPayment,
                    data: {
                      breadcrumb: "Edit Tenant Details",
                    },
                  },
                ],



              }
            ]
          },]
      },
      {
        path: "createWatchGuardContract",
        component: CreateWatcGuardContractComponent,
        data: {
          breadcrumb: "Create WatchGuard Contract",
        },
      },
      {
        path: "createAdobeReseller",
        component: CreateAMPResellerComponent,
        data: {
          breadcrumb: "Create Adobe Reseller",
        },
      },
      //manageAnnuities Route
      {
        path: "manageAnnuities/:programType",
        component: ManageAnnuitiesComponent,
        data: {
          breadcrumb: "programType",
        },
        children: [
          {
            path: "ADKDetails/:tenantId",
            component: ManageAdkdetailsComponent,
            canDeactivate: [PendingChangesGuard],
            data: {
              breadcrumb: "tenantId",
            },
            children: [
              {
                path: "AddADKSubscription",
                component: AddAdkSubscriptionComponent,
                data: {
                  breadcrumb: "Add Subscriptions",
                },
              },
              {
                path: "EditPaymentDetails",
                component: SubscriptionEditPayment,
                data: {
                  breadcrumb: "Edit Tenant Details",
                },
                children: [
                  {
                    path: "CreateDigitalWallet",
                    component: AddDigitalWalletComponent,
                    data: {
                      breadcrumb: "Digital Wallet",
                    },
                  }
                ]
              },
            ],
          },
          {
            path: "CSPDetailsNew/:tenantId",
            component: ManageCspDetailsComponent,
            data: {
              breadcrumb: "tenantId",
            },
            children: [
              {
                path: "EditEndUser",
                component: EditEndUserDetailComponent,
                data: {
                  breadcrumb: "Edit Tenant Details",
                },
              },
              {
                path: "EditPaymentDetails",
                component: EditPaymentDetailComponent,
                data: {
                  breadcrumb: "Edit Tenant Details",
                },
                children: [
                  {
                    path: "CreateDigitalWallet",
                    component: AddDigitalWalletComponent,
                    data: {
                      breadcrumb: "Digital Wallet",
                    },
                  }
                ]
              },
              {
                path: "AddSubscriptions",
                component: AddSubscriptionsComponent,
                data: {
                  breadcrumb: "Add Subscriptions",
                },
              },
              //configure portal management
              {
                path: "ConfigurePortalManagement",
                component: ConfigurePortalManagement,
                data: {
                  breadcrumb: "Configure End User Portal",
                },
              },
              //add product list
              {
                path: "AddProducts/:productType",
                component: AddProductsComponent,
                data: {
                  breadcrumb: "Add Products",
                },
                children: [
                  {
                    path: "ConfirmProductsV2",
                    component: ConfirmProductsV2Component,
                    data: {
                      breadcrumb: "Confirm Products",
                    },
                  },
                  {
                    path: "ConfirmProducts",
                    component: ConfirmProductsComponent,
                    data: {
                      breadcrumb: "Confirm Products",
                    },
                  },
                ]
              },
              {
                path: "AddAddon/:stockCode/:subscriptionId",
                component: AddAddonComponent,
                data: {
                  breadcrumb: "Add Addon",
                },
              },
              // upgrade subscription
              {
                path: "ManageLicenseSubscriotion/:menuTitle",
                component: ManageLicenseSubscriptionComponent,
                data: {
                  breadcrumb: "Manage Subscription",
                },
                children: [
                  {
                    path: 'ConfirmUpgrade/:catalogItemId',
                    component: ConfirmUpgradeComponent,
                    data: {
                      breadcrumb: "Confirm Upgrade",
                    },
                  },
                  {
                    path: 'ConfirmRenewal/:catalogItemId',
                    component: ConfirmRenewalComponent,
                    data: {
                      breadcrumb: "Confirm Rnewal",
                    },
                  }
                ]
              },
              {
                path: "ManageReservedInstance",
                component: ManageReservedInstanceComponent,
                data: {
                  breadcrumb: "Manage Reserved Instance",
                }
              },
              {
                path: "ManageAzureSubscription/:menuTitle/:scopeForBudget",
                component: ManageAzureSubscriptionComponent,
                data: {
                  breadcrumb: "Manage Azure Subscription",
                },
                children: [
                  {
                    path: 'ConfirmUpgrade/:catalogItemId',
                    component: ConfirmUpgradeComponent,
                    data: {
                      breadcrumb: "Confirm Upgrade",
                    },
                  },
                  {
                    path: "BudgetAlertDetails/:budgetName",
                    component: BudgetAndAlertsDetailsComponent,
                    data: {
                      breadcrumb: "budgetName"
                    },
                  },
                  {
                    path: "BudgetAlertEdit/:budgetName",
                    component: BudgetAndAlertsEditComponent,
                    data: {
                      breadcrumb: "budgetName"
                    },
                  },
                  {
                    path: "createBudget/:scopeId",
                    component: BudgetAndAlertsEditComponent,
                    data: {
                      breadcrumb: "Create Budget"
                    },
                  }
                ]
              },
              {
                path: "Budget&Alerts",
                component: BudgetAndAlertsComponent,
                data: {
                  breadcrumb: "Budget & Alerts",
                }
              },
              {
                path: "AddPerpetual",
                component: AddPerpetualComponent,
                data: {
                  breadcrumb: "Add Perpetual",
                },
              },
              {
                path: "AddAzureRi",
                component: AddAzureRiComponent,
                data: {
                  breadcrumb: "Add AzureRi",
                },
                children: [
                  {
                    path: "SelectAzureRi/:catalogueId",
                    component: SelectAzureRiComponent,
                    data: {
                      breadcrumb: "Select Azure Ri",
                    },
                  },
                ],
              },
              {
                path: "AddSoftware",
                component: AddSoftwareComponent,
                data: {
                  breadcrumb: "Add Software",
                },
              },
            ],
          },
          // AMP detail
          {
            path: "AMPDetails/:tenantId",
            component: ManageAMPCustomerComponent,
            data: {
              breadcrumb: "tenantId",
            },
            children: [
              {
                path: "EditAMPEndUser",
                component: AMPCustomerDetailsEditComponent,
                data: {
                  breadcrumb: "Edit Customer Details",
                },
              },
              {
                path: "AddAMPProducts/:category",
                component: AddAMPProductsV2Component,
                data: {
                  breadcrumb: "Add Adobe Products",
                },
                children: [
                  {
                    path: "ConfirmAMPProducts",
                    component: ConfirmAMPProductsComponent,
                    data: {
                      breadcrumb: "Confirm Adobe Products",
                    },
                  }
                ]
              },
              {
                path: "ManageSubscriotion/:subId",
                component: ManageAMPSubscriptionComponent,
                data: {
                  breadcrumb: "Manage Subscription",
                },
                children: [
                  {
                    path: "Cancellation/:offerId",
                    component: AMPSubscriptionCancellationComponent,
                    data: {
                      breadcrumb: "Cancellation"
                    },
                  }
                ]
              },
              {
                path: "ManageSubscriotionScheduled/:subId",
                component: ManageAMPSubscriptionScheduledComponent,
                data: {
                  breadcrumb: "Manage Subscription Scheduled",
                }
              },
              {
                path: "RenewAMPProducts",
                component: RenewAMPProductsComponent,
                data: {
                  breadcrumb: "Renew Adobe Products",
                },
              },
              {
                path: "ViewHighGrowthOffers",
                component: ViewHighGrowthOffersComponent,
                data: {
                  breadcrumb: "View High Growth Offers",
                },
                children: [
                  {
                    path: "RenewAMPProductsHGO",
                    component: RenewAMPProductsHGOComponent,
                    data: {
                      breadcrumb: "Renew Adobe Products HGO",
                    },
                  },
                  {
                    path: "ConfirmAMPProducts",
                    component: ConfirmAMPProductsComponent,
                    data: {
                      breadcrumb: "Confirm Adobe Products",
                    },
                  }
                ]
              },
              {
                path: "EditPaymentDetails",
                component: AMPEditPaymentDetailComponent,
                data: {
                  breadcrumb: "Edit Tenant Details",
                },
                children: [
                  {
                    path: "CreateDigitalWallet",
                    component: AddDigitalWalletComponent,
                    data: {
                      breadcrumb: "Digital Wallet",
                    },
                  }
                ]
              },
            ],
          },
          {
            path: "manage/:tenantId",
            component: ManageWGSEndUserComponent,
            data: {
              breadcrumb: "tenantId",
            },
            children: [
              {
                path: "EditWGSEndUser",
                component: WGSEndUserDetailsEditComponent,
                data: {
                  breadcrumb: "Edit Tenant Details",
                },
              },
              {
                path: "AddSubscriptions",
                component: AddSubscriptionsComponent,
                data: {
                  breadcrumb: "Add Subscriptions",
                },
              },
              {
                path: "AddWGSProducts",
                component: AddWGSProductsComponent,
                data: {
                  breadcrumb: "Add Watchguard Products",
                },
                children: [
                  {
                    path: "ConfirmProducts",
                    component: ConfirmWGSProductsComponent,
                    data: {
                      breadcrumb: "Confirm Products",
                    },
                  },
                ],
              },
              {
                path: "subscription/:subId",
                component: ManageWatchguardSubscriptionComponent,
                data: {
                  breadcrumb: "Manage Subscription",
                }
              }
            ]
          },
          {
            path: "createEndUser",
            component: CreateEndUserComponent,
            data: {
              breadcrumb: "Create New End User",
            },
          },
          {
            path: "createAMPCustomer",
            component: CreateAMPCustomerComponent,
            data: {
              breadcrumb: "Create Customer",
            },
          },
          {
            path: "manageAMPReseller",
            component: AMPResellerEditComponent,
            data: {
              breadcrumb: "Manage Reseller Account",
            },
          },
          {
            path: "createKaspEndUser",
            component: CreateKaspEndUserComponent,
            data: {
              breadcrumb: "Create New End User",
            },
          },
          {
            path: "createCirrusEndUser",
            component: CreateCirrusEndUserComponent,
            data: {
              breadcrumb: "Create New End User",
            },
          },
          {
            path: "associateExistingEndUser",
            component: AssociateExistingEndUserComponent,
            data: {
              breadcrumb: "Associate Existing End User",
            },
          },
          {
            path: "associateAdobeCustomer",
            component: AssociateAdobeCustomerComponent,
            data: {
              breadcrumb: "Change Reseller",
            },
          },
          {
            path: "VIPMarketPlaceMigrations",
            component: VIPMarketPlaceMigrationsComponent,
            data: {
              breadcrumb: "VIP Market Place Migrations",
            },
          },
          {
            path: "VIPMarketPlaceBulkMigrations",
            component: VIPMarketPlaceBulkMigrationsComponent,
            data: {
              breadcrumb: "VIP Market Place Bulk Migrations",
            },
          },
          {
            path:
              "SKBAKDetails/:annuityId/:orderNo",
            component: ManageSKReadOnlyComponent,
            data: {
              breadcrumb: "vendorAgreementNo",
            },
            children: [
              {
                path: "EditPaymentDetails",
                component: SubscriptionEditPayment,
                data: {
                  breadcrumb: "Edit Payment Details",
                },
                children: [
                  {
                    path: "CreateDigitalWallet",
                    component: AddDigitalWalletComponent,
                    data: {
                      breadcrumb: "Digital Wallet",
                    },
                  }
                ]
              },
            ]
          },
          {
            path:
              "SPLADetails/:annuityId/:orderNo/:vendorAgreementNo/:orderSuffix",
            component: ManageSpladetailsComponent,
            data: {
              breadcrumb: "vendorAgreementNo",
            },
            children: [
              {
                path: "AddSplaSubscriptions",
                component: AddSplaSubscriptionsComponent,
              },
              {
                path: "EditPaymentDetails",
                component: SubscriptionEditPayment,
                data: {
                  breadcrumb: "Edit Payment Details",
                },
                children: [
                  {
                    path: "CreateDigitalWallet",
                    component: AddDigitalWalletComponent,
                    data: {
                      breadcrumb: "Digital Wallet",
                    },
                  }
                ]
              },
            ],
          },
          {
            path: 'SPLADetails/:annuityId/:orderNo/:vendorAgreementNo',
            component: ManageSpladetailsComponent,
            data: {
              breadcrumb: 'vendorAgreementNo',
            },
            children: [
              {
                path: 'AddSplaSubscriptions',
                component: AddSplaSubscriptionsComponent,
                canDeactivate: [PendingChangesGuard]
              },
              {
                path: "EditPaymentDetails",
                component: SubscriptionEditPayment,
                data: {
                  breadcrumb: "Edit Payment Details",
                },
                children: [
                  {
                    path: "CreateDigitalWallet",
                    component: AddDigitalWalletComponent,
                    data: {
                      breadcrumb: "Digital Wallet",
                    },
                  }
                ]
              },
            ]
          },
          {
            path: "ReadOnlySPLADetails/:annuityId/:orderNo/:vendorAgreementNo",
            component: ManageSpladetailsComponent,
            data: {
              breadcrumb: "vendorAgreementNo",
            },
            children: [
              {
                path: "EditPaymentDetails",
                component: SubscriptionEditPayment,
                data: {
                  breadcrumb: "Edit Tenant Details",
                },
                children: [
                  {
                    path: "CreateDigitalWallet",
                    component: AddDigitalWalletComponent,
                    data: {
                      breadcrumb: "Digital Wallet",
                    },
                  }
                ]
              },
            ]
          },
          {
            path:
              "ReadOnlySPLADetails/:annuityId/:orderNo/:vendorAgreementNo/:orderSuffix",
            component: ManageSpladetailsComponent,
            data: {
              breadcrumb: "vendorAgreementNo",
            },
            children: [
              {
                path: "EditPaymentDetails",
                component: SubscriptionEditPayment,
                data: {
                  breadcrumb: "Edit Tenant Details",
                },
                children: [
                  {
                    path: "CreateDigitalWallet",
                    component: AddDigitalWalletComponent,
                    data: {
                      breadcrumb: "Digital Wallet",
                    },
                  }
                ]
              },
            ]
          },
          {
            path: "SubscriptionDetails/:tenantId",
            component: ManageSubscriptiondetailsComponent,
            canDeactivate: [PendingChangesGuard],
            data: {
              breadcrumb: "tenantId",
            },
            children: [
              {
                path: "EditPaymentDetails",
                component: SubscriptionEditPayment,
                data: {
                  breadcrumb: "Edit Tenant Details",
                },
                children: [
                  {
                    path: "CreateDigitalWallet",
                    component: AddDigitalWalletComponent,
                    data: {
                      breadcrumb: "Digital Wallet",
                    },
                  }
                ]
              },
            ],
          },
          {
            path: "KASPDetails/:tenantId",
            component: ManageKaspDetailsComponent,
            canDeactivate: [PendingChangesGuard],
            data: {
              breadcrumb: "tenantId",
            },
            children: [
              {
                path: "AddKASPSubscriptions",
                component: AddKaspSubscriptionComponent,
                data: {
                  breadcrumb: "Add KASP Subscriptions",
                },
              },
              {
                path: "EditEndUser",
                component: EditKaspEndUserComponent,
                data: {
                  breadcrumb: "Edit Tenant Details",
                },
              },
              {
                path: "EditPaymentDetails",
                component: SubscriptionEditPayment,
                data: {
                  breadcrumb: "Edit Tenant Details",
                },
                children: [
                  {
                    path: "CreateDigitalWallet",
                    component: AddDigitalWalletComponent,
                    data: {
                      breadcrumb: "Digital Wallet",
                    },
                  }
                ]
              },
            ],
          },
          {
            path: "CIRRUSDetails/:tenantId",
            component: ManageCirrusDetailsComponent,
            canDeactivate: [PendingChangesGuard],
            data: {
              breadcrumb: "tenantId",
            },
            children: [
              {
                path: "AddCirrusSubscriptions",
                component: AddCirrusSubscriptionComponent,
                data: {
                  breadcrumb: "Add Cirrus Subscriptions",
                },
              },
              {
                path: "EditEndUser",
                component: EditCirrusEndUserComponent,
                data: {
                  breadcrumb: "Edit Tenant Details",
                },
              },
              {
                path: "EditPaymentDetails",
                component: SubscriptionEditPayment,
                data: {
                  breadcrumb: "Edit Tenant Details",
                },
                children: [
                  {
                    path: "CreateDigitalWallet",
                    component: AddDigitalWalletComponent,
                    data: {
                      breadcrumb: "Digital Wallet",
                    },
                  }
                ]
              },
            ],
          },
          {
            path: "subscription/:subId",
            component: ManageWatchguardSubscriptionComponent,
            data: {
              breadcrumb: "Manage Subscription",
            }
          },
          {
            path: "AddWGSProducts",
            component: AddWGSProductsComponent,
            data: {
              breadcrumb: "Add Watchguard Products",
            },
            children: [
              {
                path: "ConfirmProducts",
                component: ConfirmWGSProductsComponent,
                data: {
                  breadcrumb: "Confirm Products",
                },
              },
            ],
          },
          {
            path: "bulkAssociate",
            component: BulkAssociateComponent,
            data: {
              breadcrumb: "Bulk Associate",
            },
          },
          {
            path: "bulkOrder",
            component: BulkOrderComponent,
            data: {
              breadcrumb: "Bulk Order",
            },
          },
          {
            path: "bulkTransfer",
            component: BulkTransferComponent,
            data: {
              breadcrumb: "Bulk Transfer",
            },
          },
        ],
      },
    ],
  },
  {
    path: 'subscriptions',
    redirectTo: '/manageSubscriptions',
    pathMatch: 'full'
  },
  // {
  //   path: "manageSubscriptions/:cmsid",
  //   component: ManageSubscriptionsComponent,
  // },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ManageSubscriptionsRoutingModule { }
